import { AuthenticationState } from '../models/authentication-state';
import { RootState } from '../store';

export const currentAuthenticationState = (state: RootState): AuthenticationState => state.authentication;
